import {register} from '../vendor/theme-scripts/theme-sections';
import {slider} from '../features/slider';
import {videoPlay} from '../features/video-play';
import blockScroll from '../features/block-scroll';

register('columns-with-image', [slider, blockScroll, videoPlay]);
